import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

export const StyledContainer = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid ${colorPalette.blue200};
  position: sticky; /* Keeps it below navbar */
  top: 70px; /* Matches Navbar height */
  background: white;
  z-index: 999; /* Below navbar but above content */

  @media (max-width: 768px) {
    top: 50px;
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto;
  position: relative;
  margin-top: 30px;
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  position: relative;
  text-align: center;
`;

export const Step = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>`
  ${typeScale.bodyXS};
  font-weight: ${({ active }) => (active ? 700 : 500)};
  text-align: center;
  color: ${colorPalette.textMain};

  /* Hide text on mobile */
  @media (max-width: 768px) {
    font-size: 0;
  }

  &::before {
    content: "";
    width: 14px;
    height: 14px;
    background-color: ${({ active }) =>
      active ? colorPalette.blue500 : colorPalette.blue300};
    border-radius: 50%;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: -15px;
  left: 12.5%;
  width: 75%;
  height: 4px;
  background-color: ${colorPalette.blue200};
  z-index: 1;
`;

export const ProgressFill = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "progress",
})<{ progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background: linear-gradient(90deg, #7fccfa 0%, #276ef1 100%);
  transition: width 0.3s ease-in-out;
  border-radius: 2px;
`;
